import {
  VehicleManufacturer,
  VehicleManufacturerRow,
} from "./types";

/*---------------------------------------------------------------------------------------
    VEHICLE MANUFACTURER SEARCH
  -----------------------------------------------------------------------------------------*/

export const transformVehicleManufacturerRow = (
  res: any
): VehicleManufacturerRow => {
  return {
    id: res.id,
    image: res.image,
    name: res.name,
    primary: res.primary ?? false,
    displayOrder: res.displayOrder ?? 0,
  };
};

/*---------------------------------------------------------------------------------------
    VEHICLE MANUFACTURER  CREATE/EDIT
  -----------------------------------------------------------------------------------------*/

  export const transformVehicleManufacturer = (res: any): VehicleManufacturer => {
  return {
    id: res.id,
    name: res.name,
    image: res.image,
  };
};
